import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { Code, Briefcase, GraduationCap, Rocket, ArrowRight } from "lucide-react";

const areas = [
  { icon: Code, title: "AI Engineering", desc: "Build sovereign LLMs, voice AI, and edge ML systems that power India's future." },
  { icon: Briefcase, title: "Product & Strategy", desc: "Shape the future of private AI across industries with deep domain expertise." },
  { icon: GraduationCap, title: "Research", desc: "Advance the frontier of secure, efficient, and sovereign AI systems." },
  { icon: Rocket, title: "Business Development", desc: "Expand Ojas AI's reach across India and beyond with strategic partnerships." },
];

export const CareersSection = () => (
  <section id="careers" data-testid="careers-section" className="py-24 md:py-32 relative">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <div className="glass-card rounded-2xl p-8 md:p-16 relative overflow-hidden">
        <div className="absolute top-0 right-0 w-96 h-96 bg-[#c9a84c]/5 rounded-full blur-3xl" />
        <div className="relative z-10">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <p className="text-[#c9a84c] font-heading font-semibold text-sm tracking-widest uppercase mb-4">
              Careers
            </p>
            <h2 className="font-heading font-bold text-3xl sm:text-4xl text-foreground tracking-tight">
              Build India's <span className="text-gradient-gold">AI Future</span>
            </h2>
            <p className="font-body text-muted-foreground mt-4 max-w-2xl leading-relaxed">
              Join a team of domain experts with vivid experience across
              prestigious global organisations — now building sovereign AI systems
              that matter. We're looking for passionate builders ready to shape
              India's technological destiny.
            </p>
          </motion.div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 mt-10">
            {areas.map((a, i) => (
              <motion.div
                key={a.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: i * 0.1 }}
                className="rounded-lg p-5 border border-[#c9a84c]/10 hover:border-[#c9a84c]/30 transition-colors duration-300 bg-background/50"
                data-testid={`career-area-${i}`}
              >
                <a.icon className="h-6 w-6 text-[#c9a84c] mb-3" />
                <h3 className="font-heading font-semibold text-foreground text-sm">{a.title}</h3>
                <p className="font-body text-muted-foreground text-xs mt-1 leading-relaxed">{a.desc}</p>
              </motion.div>
            ))}
          </div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.4 }}
            className="mt-10"
          >
            <Button
              onClick={() => document.querySelector("#contact")?.scrollIntoView({ behavior: "smooth" })}
              className="bg-[#c9a84c] text-[#0a1628] font-heading font-semibold px-8 py-6 group"
              data-testid="careers-cta"
            >
              Get in Touch
              <ArrowRight className="ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform duration-200" />
            </Button>
          </motion.div>
        </div>
      </div>
    </div>
  </section>
);
